// apps/web/src/lib/kanban/tablet-api.ts — Fase 11, Plano 15.
// Chamadas HTTP do tablet: cookie de sessão + CSRF + cabeçalhos do dispositivo.
import { apiMutate } from '../csrf-fetch';
import { cabecalhosDispositivo, type CredencialDispositivo } from './dispositivo';

export interface RespostaTablet<T> {
  status: number;
  ok: boolean;
  dados: T | null;
  mensagem: string | null;
  reason: string | null;
}

export async function postarTablet<T>(
  credencial: CredencialDispositivo,
  caminho: string,
  corpo: unknown,
): Promise<RespostaTablet<T>> {
  const res = await apiMutate(`/api/v1/kanban/tablet/${caminho}`, {
    method: 'POST',
    body: corpo,
    headers: cabecalhosDispositivo(credencial),
  });
  const json = (await res.json().catch(() => null)) as (T & { message?: unknown; reason?: unknown }) | null;
  return {
    status: res.status,
    ok: res.ok,
    dados: res.ok ? (json) : null,
    mensagem: !res.ok && json && typeof json.message === 'string' ? json.message : null,
    reason: !res.ok && json && typeof json.reason === 'string' ? json.reason : null,
  };
}
